import { apiClient } from '../config'

export type GcpLogEntry = {
  insertId: string
  timestamp: string
  severity: string
  logName: string
  textPayload?: string
  jsonPayload?: Record<string, unknown>
  resource?: {
    type: string
    labels: Record<string, string>
  }
  labels?: Record<string, string>
}

export type GcpLogsQueryResponse = {
  entries: GcpLogEntry[]
  count: number
  keyword: string
}

type QueryGcpLogsParams = {
  keyword: string
  startTime?: string
  endTime?: string
  limit?: number
}

const GCP_LOGS_QUERY_TIMEOUT_MS = 240000

export const gcpLogsService = {
  queryLogs: async (params: QueryGcpLogsParams): Promise<GcpLogsQueryResponse> => {
    const response = await apiClient.get<GcpLogsQueryResponse>('/admin/gcp-logs', {
      params,
      timeout: GCP_LOGS_QUERY_TIMEOUT_MS,
    })
    return response.data
  },
}
